class LqdColumnsWrap extends Marionette.Behavior {

  initialize() {

    super.initialize();

    _.defer(() => {
      const settings = this.view.model.get('settings');
      this.listenTo(settings, 'change:liquid_columns_wrap', this.onColumnWrapChange);
      this.handleResize(settings.get('liquid_columns_wrap'));
    })

  }

  onColumnWrapChange({changed}) {

    this.handleResize(changed.liquid_columns_wrap);
    
  }

  handleResize(columnWrap) {

    const resizeHooks = ['resize-column', 'resize-column-limit'];

    if ( columnWrap === 'yes' ) {
      resizeHooks.forEach(hook => {
        $e.hooks.data.callbacksFlatList[hook].deactivate()
      })
    } else {
      resizeHooks.forEach(hook => {
        $e.hooks.data.callbacksFlatList[hook].activate()
      })
    }

  }

}

elementor.hooks.addFilter('elements/section/behaviors', (behaviors, sectionView) => {

    behaviors.liquidColumnsWrap = {
      behaviorClass: LqdColumnsWrap
    };

    sectionView.adjustColumns = function() {
      
      if ( this.model.get("settings").get("liquid_columns_wrap") === "yes" ) return;
  
      const preset = elementor.presetsFactory.getPresetByStructure( this.getStructure() );
      
      this.children.each( ( columnView, index ) => {
        const container = columnView.getContainer();
        
        $e.run( 'document/elements/settings', {
          container,
          settings: {
            _column_size: preset.preset[ index ],
            _inline_size: null,
          },
        } );
      });
    };

    return behaviors;

});